import cx from 'classnames';

import { StarIcon } from '@motorway/mw-highway-code';
import { Size } from '@motorway/mw-highway-code/src/types';

import styles from './StarRating.module.scss';

export const StarRating = ({ rating, size = 'xsmall' }: { rating: number; size?: Size }) => {
  const filledStars = Math.floor(rating);
  const remainder = rating - filledStars;

  const getStarType = (index: number) => {
    if (index < filledStars) {
      return 'full';
    }
    if (index === filledStars && remainder > 0) {
      return 'partial';
    }
    return 'empty';
  };

  return (
    <div className={styles.container} style={{ '--star-fill-amount': remainder } as React.CSSProperties}>
      {Array.from({ length: 5 }, (_, i) => {
        const starType = getStarType(i);
        return (
          <div key={i} className={styles.star}>
            <StarIcon filled size={size} />
            {starType !== 'empty' && (
              <div className={cx(styles.starFilled, { [styles.partial]: starType === 'partial' })}>
                <StarIcon filled size={size} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
